import { Cookies } from 'react-cookie'
import { CURRENCY_COOKIE_NAME } from 'constants/cookies'
import { getApexCookieDomain, getCookieDomainCandidates } from 'utils/cookie-domain'

const CURRENCY_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

interface CurrencyCookieOptions {
  path?: string
  domain?: string
  maxAge?: number
}

export interface WriteCurrencyPreferenceCookieInput {
  hostname: string
  setCookie: (
    name: typeof CURRENCY_COOKIE_NAME,
    value: string,
    options?: CurrencyCookieOptions,
  ) => void
  removeCookie: (name: typeof CURRENCY_COOKIE_NAME, options?: CurrencyCookieOptions) => void
}

export function writeCurrencyPreferenceCookie(
  currency: string,
  { hostname, setCookie, removeCookie }: WriteCurrencyPreferenceCookieInput,
) {
  for (const domain of getCookieDomainCandidates(hostname)) {
    removeCookie(CURRENCY_COOKIE_NAME, { path: '/', domain })
  }
  // WordPress can leave narrower cookies that shadow the shared-domain value.
  removeCookie(CURRENCY_COOKIE_NAME, { path: '/' })
  removeCookie(CURRENCY_COOKIE_NAME, { path: '/', domain: 'staging.creativefabrica.com' })

  const value = currency.toUpperCase()
  const cookieOptions = { path: '/', maxAge: CURRENCY_COOKIE_MAX_AGE_SECONDS } as const
  const apexDomain = getApexCookieDomain(hostname)
  if (apexDomain) {
    setCookie(CURRENCY_COOKIE_NAME, value, { ...cookieOptions, domain: apexDomain })
  }
  if (new Cookies().get(CURRENCY_COOKIE_NAME) !== value) {
    setCookie(CURRENCY_COOKIE_NAME, value, cookieOptions)
  }

  return new Cookies().get(CURRENCY_COOKIE_NAME) === value
}
